import { Country, countries } from '../../lib/countries';
import { GetCnpjIntegrationDTO } from '../../types/cnpjIntegration.types';
import { CreateAccountStore } from './types/createAccount.types';
import { SignUpState, SignUpSteps, SignUpUserMode } from './types/signUp.types';

export const signUpInitialState: SignUpState = {
  currentStep: SignUpSteps.LOCATION_AND_CNPJ,
  location: countries[0],
  cnpj: '',
  store: {},
  cnpjStatus: 'unset',
  errorMessage: '',
  userMode: 'NEW',
};

export const signUpReducer = (state: SignUpState, action: any): SignUpState => {
  switch (action.type) {
    case 'SET_LOCATION':
      return {
        ...state,
        location: action.payload,
      };
    case 'SET_CNPJ':
      return {
        ...state,
        cnpj: action.payload,
      };
    case 'START_FETCH_CNPJ':
      return {
        ...state,
        cnpjStatus: 'loading',
      };
    case 'FETCH_CNPJ_ERROR':
      return {
        ...state,
        cnpjStatus: 'error',
        errorMessage: action.payload,
      };
    case 'FETCH_CNPJ_ALREADY_EXISTS_ERROR':
      return {
        ...state,
        cnpjStatus: 'cnpjAlreadyExists',
        errorMessage: action.payload,
      };
    case 'FETCH_CNPJ_SUCCESS':
      if (!action?.payload.cnpj) {
        return {
          ...state,
          cnpjStatus: 'success',
          store: {
            cpfcnpj: action.payload.cnpjField,
          },
        };
      }

      return {
        ...state,
        cnpjStatus: 'success',
        store: {
          cpfcnpj: action.payload?.cnpj,
          ...action.payload,
          phone: action.payload?.phone ? `55${action.payload?.phone}` : null,
        },
      };
    case 'RESET_CNPJ_STATUS':
      return {
        ...state,
        cnpjStatus: 'unset',
        store: {},
      };
    case 'CHANGE_STEP':
      return {
        ...state,
        currentStep: action.payload,
      };
    case 'COMPLETE_STORE_STEP':
      return {
        ...state,
        store: action.payload,
      };
    case 'SET_USER_MODE':
      return {
        ...state,
        userMode: action.payload,
      };
    default:
      throw new Error('Ação do reducer não encontrada');
  }
};

export const setLocation = (payload: Country) => ({
  type: 'SET_LOCATION',
  payload,
});

export const setCnpj = (payload: string) => ({
  type: 'SET_CNPJ',
  payload,
});

export const startFetchCnpj = () => ({ type: 'START_FETCH_CNPJ' });

export const fetchCnpjError = (payload: string) => ({
  type: 'FETCH_CNPJ_ERROR',
  payload,
});

export const fetchCnpjAlreadyExistsError = (payload: string) => ({
  type: 'FETCH_CNPJ_ALREADY_EXISTS_ERROR',
  payload,
});

export const fetchCnpjSuccess = (payload?: GetCnpjIntegrationDTO, cnpjField?: string) => ({
  type: 'FETCH_CNPJ_SUCCESS',
  payload: {
    ...payload,
    cnpjField,
  },
});

export const resetCnpjStatus = () => ({ type: 'RESET_CNPJ_STATUS' });

export const changeStep = (payload: SignUpSteps) => ({
  type: 'CHANGE_STEP',
  payload,
});

export const completeStoreStep = (payload: CreateAccountStore) => ({
  type: 'COMPLETE_STORE_STEP',
  payload,
});

export const setUserMode = (payload: SignUpUserMode) => ({
  type: 'SET_USER_MODE',
  payload,
});
